export enum RuleGridType {
    PrincipalTwentyPercentResidential = 0,
    PrincipalTwentyPercentCommercial = 1,
    PrincipalLicensedGC = 2,
}
